import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const getHeaders = () => ({
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
});

export const uploadCvtLogsService = {
  getRecordsRange: async (startDate, endDate) => {
    const url = `${domain}/api/TimeLogRaw/cvt-logs/range?startDate=${startDate}&endDate=${endDate}`;
    return await axios.get(url, { headers: getHeaders() });
  },

  bulkUpload: async (payload) => {
    const url = `${domain}/api/TimeLogRaw/upload-cvt-logs`;
    return await axios.post(url, payload, { headers: getHeaders() });
  },

  getEmployeeMasterlist: async () => {
    const url = `${domain}/api/Employee/masterlist`;
    return await axios.get(url, { headers: getHeaders() });
  }
};